import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { ContactForm } from '../components/ContactForm';
import { usePageMeta } from '../hooks/usePageMeta';
import { PHONE_DISPLAY, PHONE_HREF, trackCallConversion } from '../utils/phone';
import { SERVICE_AREA_CITIES } from '../utils/seo';
export function ContactPage() {
  usePageMeta({
    title: "Contact & Get a Quote | Mike's Pro Detail",
    description: "Request a free mobile detailing quote from Mike's Pro Detail, or call or text 818-381-9905. Serving Camarillo, Oxnard, Ventura, Thousand Oaks and all of Ventura County.",
    path: '/contact',
    breadcrumbName: 'Contact'
  });
  return <main data-id="element-641" data-mp="f05xdnjjfxu0">
      <PageHeader breadcrumb="Contact" title="Contact Mike's Pro Detail" subtitle="Call or text for the fastest answer, or send a quote request and Mike will get back to you shortly." showCta={false} data-id="element-642" data-mp="ewrvship7snm" />

      <section className="w-full bg-black py-16 px-4" data-id="element-643" data-mp="1qg49k0a0izzg">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-10 lg:gap-14 items-start" data-id="element-644" data-mp="qznb0to4r4mf">
          <div className="space-y-10" data-id="element-645" data-mp="mzl5g9f9xr1v">
            <a href={PHONE_HREF} onClick={trackCallConversion} className="block p-6 sm:p-8 bg-zinc-900 border-2 border-red-600 rounded-2xl hover:bg-zinc-800 transition-colors duration-150" aria-label={`Call or text Mike's Pro Detail at ${PHONE_DISPLAY}`} data-id="element-646" data-mp="i006hz03tip5">
              <span className="block text-sm uppercase tracking-widest text-gray-400 font-bold" data-id="element-647" data-mp="83dm1bbowtnn">
                Call or Text
              </span>
              <span className="mt-2 flex items-center gap-3" data-id="element-648" data-mp="3ven2gbta8v90">
                <Phone className="w-7 h-7 shrink-0 text-red-500" aria-hidden="true" data-id="element-649" data-mp="3vf4v6ygqkrc6" />
                <span className="text-3xl sm:text-4xl font-black text-white tracking-tight whitespace-nowrap" data-id="element-650" data-mp="3qhd4u8vqpda3">
                  {PHONE_DISPLAY}
                </span>
              </span>
              <span className="mt-3 block text-gray-400" data-id="element-651" data-mp="3gixdq5wpq40l">
                Tap to call on mobile.
              </span>
            </a>

            <div data-id="element-652" data-mp="36w37ge9pksif">
              <h2 className="text-xl font-black uppercase text-white" data-id="element-653" data-mp="3bt3d4o2nbt90">
                Service Area
              </h2>
              <p className="mt-2 text-gray-400 leading-relaxed" data-id="element-654" data-mp="2xttulhqywn1v">
                We're fully mobile and come to you throughout Ventura County and
                select surrounding areas.
              </p>
              <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2" data-id="element-655" data-mp="3pk8657bidnad">
                {SERVICE_AREA_CITIES.map(city => <li key={city} data-id="element-656" data-mp="3ujukxl6zjbla">
                    <Link to={`/mobile-detailing-${city.toLowerCase().replace(/\s+/g, '-')}`} className="inline-flex items-center gap-2 text-gray-300 hover:text-yellow-400 transition-colors duration-150" data-id="element-657" data-mp="3uit4f1779ww6">
                      <MapPin className="w-4 h-4 text-red-500 shrink-0" aria-hidden="true" data-id="element-658" data-mp="3kror05x6ak3g" />
                      {city}
                    </Link>
                  </li>)}
              </ul>
            </div>

            <div data-id="element-659" data-mp="h6sq5gummg89">
              <h2 className="text-xl font-black uppercase text-white" data-id="element-660" data-mp="21v3iug7rksz3">
                What We Need From You
              </h2>
              <p className="mt-2 text-gray-400 leading-relaxed" data-id="element-661" data-mp="1wwsayb114sji">
                We bring our own water and detailing equipment. We require
                access to a standard electrical outlet at the service location.
              </p>
              <Link to="/faq" className="mt-3 inline-block text-yellow-400 font-bold hover:text-yellow-300 transition-colors duration-150" data-id="element-662" data-mp="26mlkz7liwzln">
                More answers in our FAQ &rarr;
              </Link>
            </div>
          </div>

          <ContactForm data-id="element-663" data-mp="1su5chr9us9dc" />
        </div>
      </section>
    </main>;
}